(function (factory) {
    if (typeof define === 'function' && define.amd) {
        // AMD. Register as an anonymous module.
        define(function (require, exports, module ) {
            return factory(
                require('./SwitchBoard'),
                require('./Topic')
            );
        });
    } else if (typeof module === 'object' && module.exports) {
        // CommonJS
        module.exports = factory(
            require('./SwitchBoard'),
            require('./Topic')
        );
    } else{
        root.MessageServiceChannel=factory(
            root.MessageServiceSwitchBoard,
            root.MessageServiceTopic 
        );
    }
})(function(Switchboard, Topic){
    var undef = 'undefined';
    var globalChannel = typeof window !== undef ? window : typeof global !== undef ? global : this;

    var MESSAGE = "message";
    var MSG = "msg";
    var CHANNELMESSAGE = "MessageService::channel";
    var CHANNELMESSAGE_REPEATER = "MessageService::channel::repeater";
    var CHANNELMESSAGE_READY = "channel::ready";
    var CHANNELMESSAGE_ERROR = "channel::error";
    var CHANNELMESSAGE_COMPLETE = "MessageService::channel::complete";
    var CHANNELMESSAGE_DISCONNECT = "MessageService::channel::disconnect";
    var CHANNELMESSAGE_CLOSED = "channel::closed";
    var ORIGIN = "*";

    function Channel (target, handshake, initData, broker) {
        var that = this;
        this.target = target;
        this.handshake = handshake;
        this.initData = initData;
        this.initDataFromTarget = null;
        this.hub = broker.hub;
        this.messageService = broker.messageService;
        this.topics = broker.topics;
        this.channelTopics = broker.channelTopics;
        this.status = 'pending';
        this.isMessageChannel = broker.isMessageChannel;
        this.handshakeMessageCallback = function (e) {
            that.handshakeMessage(e);
        }

        this.channelRepeaterCallback = function (e) {
            that.channelRepeater(e);
        }

        this.channelConfirmationCallback = function (e) {
            that.channelConfirmation(e);
        }
    }

    Channel.events = {
        CHANNELMESSAGE: CHANNELMESSAGE,
        CHANNELMESSAGE_REPEATER: CHANNELMESSAGE_REPEATER,
        CHANNELMESSAGE_READY: CHANNELMESSAGE_READY,
        CHANNELMESSAGE_ERROR: CHANNELMESSAGE_ERROR,
        CHANNELMESSAGE_COMPLETE: CHANNELMESSAGE_COMPLETE,
        CHANNELMESSAGE_DISCONNECT: CHANNELMESSAGE_DISCONNECT,
        CHANNELMESSAGE_CLOSED: CHANNELMESSAGE_CLOSED
    };

    Channel.prototype = {

        publish: function (topic, message) {
            this.repeatToChannel({ topic: topic, msg: message});
        },

        acceptInvitation: function (port, initDataFromTarget){
            if(this.target && this.handshake && this.isMessageChannel){
                var topics = this.topics;
                var sharePort;
                var target = this.target;

                if(!port){
                    var channel = new Switchboard();
                    port = channel.port1;
                    sharePort = channel.port2;
                    this.initDataFromTarget = initDataFromTarget;
                }
                port.start();
                this.port = port;

                port.addEventListener(MESSAGE, this.channelRepeaterCallback, false);
                Topic.addTopicListener(this, this.hub, this.channelTopics, CHANNELMESSAGE_REPEATER, this.repeatToChannel, false);

                // Send port to open channel, and your initData
                if(sharePort){
                    port.addEventListener(MESSAGE, this.channelConfirmationCallback, false);
                    target.postMessage({ type : CHANNELMESSAGE, handshake : this.handshake, initData : this.initData }, ORIGIN, [sharePort]);
                } else {
                    this.status = 'ready';
                    globalChannel.removeEventListener(MESSAGE,this.handshakeMessage,false);
                    Topic.removeTopicListener(this, this.channelTopics, CHANNELMESSAGE_REPEATER, this.tempRepeater);
                    port.postMessage({ type : CHANNELMESSAGE_COMPLETE, handshake : this.handshake });
                    this.messageService.publish(CHANNELMESSAGE_READY, { id : this.handshake, data : initDataFromTarget }, true);
                }
            }
        },

        tempRepeater: function (data, evt) {
            if(data && data.topic && data.hasOwnProperty(MSG)){
                this.target.postMessage({type : CHANNELMESSAGE_REPEATER, handshake : this.handshake, topic : data.topic, msg: data.msg}, ORIGIN);
            }
        },

        handshakeMessage: function (e) {
            var trustedMessage = this.handshakeListener(this.target, e);
            if(trustedMessage){
                // Channel handshake moving forward
                if (trustedMessage === CHANNELMESSAGE) {
                    this.acceptInvitation(e.ports && e.ports[0], e.data && e.data.initData);
                } else if (trustedMessage === CHANNELMESSAGE_REPEATER){
                    var data = e.data;
                    // Handshake not complete, but we've got an incoming authorized message
                    if(data && data.topic && data.hasOwnProperty(MSG)){
                        Topic.publishTopic(this.topics[data.topic], data.msg)
                    }
                }
            }
        },

        channelRepeater: function (e) {
            var data = e.data;
            if (data && data.topic && data.hasOwnProperty(MSG)) {
                Topic.publishTopic(this.topics[data.topic], data.msg);
            } else {
                if (this.handshakeListener(this.port, e) === CHANNELMESSAGE_DISCONNECT) {
                    this.disconnect();
                }
            }
        },

        repeatToChannel: function (data, evt) {
            var target = this.target;
            var port = this.port;
            // Target has disappeared or closed - shut it down
            if(!target || target.closed===true){
                this.disconnect();
                return;
            }
            if(data && data.topic && data.hasOwnProperty(MSG)){
                port.postMessage({topic : data.topic, msg: data.msg});
            }
        },

        channelConfirmation: function (e) {
            if(this.handshakeListener(this.port, e) === CHANNELMESSAGE_COMPLETE){
                globalChannel.removeEventListener(MESSAGE,this.handshakeMessageCallback,false);
                this.port.removeEventListener(MESSAGE,this.channelConfirmationCallback,false);
                Topic.removeTopicListener(this, this.channelTopics, CHANNELMESSAGE_REPEATER, this.tempRepeater);
                this.status = 'ready';
                this.messageService.publish(CHANNELMESSAGE_READY, { id : this.handshake, data : this.initDataFromTarget }, true);
            }
        },

        connect: function () {
            var targetable = true;
            var channelErr;
            // If we're connecting two instance in the same context
            // we don't want to bother with postMessage.
            if(this.target === globalChannel){
                
            }

            globalChannel.addEventListener(MESSAGE, this.handshakeMessageCallback, false);
            Topic.addTopicListener(this, this.hub, this.channelTopics, CHANNELMESSAGE_REPEATER, this.tempRepeater, false);
            try {
                this.target.postMessage({ type : CHANNELMESSAGE, handshake : this.handshake, initData : this.initData },ORIGIN);
            } catch (channelErr) {
                targetable = false;
                channelError = channelErr;
            } finally {
                if(!targetable){
                    this.disconnect();
                    // Let the service instance know there was an error, and keep the message local
                    this.messageService.publish(CHANNELMESSAGE_ERROR, {
                        id : this.handshake,
                        data : channelError
                    }, true);
                }
            }
            return targetable;
        },

        disconnect: function () {
            var port = this.port;

            globalChannel.removeEventListener(MESSAGE, this.handshakeMessageCallback, false);                
            Topic.removeTopicListener(this, this.channelTopics, CHANNELMESSAGE_REPEATER, this.tempRepeater);
            Topic.removeTopicListener(this, this.channelTopics, CHANNELMESSAGE_REPEATER, this.repeatToChannel);

            this.status = 'closed';

            if (port) {
                port.removeEventListener(MESSAGE, this.channelRepeaterCallback, false);
                port.postMessage({ type : CHANNELMESSAGE_DISCONNECT, handshake : this.handshake });
                port.close();
            }
            
            this.messageService.publish(CHANNELMESSAGE_CLOSED, {
                id: this.handshake,
                data: this
            }, true);
        },

        handshakeListener: function (expectedTarget, message) {
            var data = message.data;
            var handshake = this.handshake;

            if(data && ( 
                data.type === CHANNELMESSAGE || 
                data.type === CHANNELMESSAGE_REPEATER || 
                data.type === CHANNELMESSAGE_COMPLETE ||
                data.type === CHANNELMESSAGE_DISCONNECT
                ) && handshake===data.handshake && expectedTarget === (message.source || message.srcElement)){
                return data.type;
            }
            return false;
        }
    }
    return Channel;
});